angular.module('dpw.directives').directive('dpwKeepMeInformed', function () {
    return {
        restrict: 'A',
        controller: ['$scope', 'trackUtil', 'api', function ($scope, trackUtil, api) {
            this.submit = function () {
                var $form = $('.subscribe-form form');
                if ($form.valid()) {
                    api.call(api.subscribe({email: $scope.email}), function () {
                        angular.isFunction($scope.onInformed) ?
                            $scope.onInformed() :
                            RCDPW.modal.create().title(RCDPW.Lang.THANK_YOU).content(RCDPW.Lang.KEEP_ME_INFORMED_SUCCESS).show();
                        trackUtil.logPageView('KeepMeInformed');
                    });
                }
            };
        }],
        controllerAs: 'ctrl',
        templateUrl: function(elem, attr) {
            return attr.page === 'index' ? 'dpw-keep-me-informed-index.html' : 'dpw-keep-me-informed.html';
        }
    };
});